<script lang="ts">
    import type {DocumentDetailReactivePageData, DocumentDetailStaticPageData} from '../types';
    import type {KpVolumesComponentCapabilities} from '../../kp-volumes/types';
    import KpVolumes from '../../kp-volumes/KpVolumes.svelte';
    import {getPageContext} from 'shared/layouts/page-context';

    const pageContext = getPageContext<DocumentDetailStaticPageData, DocumentDetailReactivePageData>();
    const model = pageContext.staticData.model;

    function createVolumesCapabilities(): KpVolumesComponentCapabilities {
        return {
            canCreateAnyVolume: model.exemplarsView.canCreateAny,
            canEditAnyVolume: model.exemplarsView.canEditAny,
            canCreateAnyExemplar: model.exemplarsView.canCreateAny,
            canEditAnyExemplar: model.exemplarsView.canEditAny
        }
    }
</script>

{#if model.record.volumeable}
    <KpVolumes document="{model.record}"
               exemplarStatuses="{model.exemplarsView.showableExemplarStatuses}"
               exemplarsListProperties="{model.exemplarsView.issueColumns}"
               capabilities="{createVolumesCapabilities()}"/>
{/if}